var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "akmdvm60oa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.854279 0 0 0 0 0.870904 0 0 0 0 0.904155 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "",
    transform: "translate(-1266 -325) translate(1223 319)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1C2154",
    fillRule: "nonzero",
    d: "M9.5.625c-.483 0-.875.392-.875.875v7c0 1.588 1.287 2.875 2.875 2.875h7c.483 0 .875-.392.875-.875 0-5.454-4.421-9.875-9.875-9.875zm.982 1.809c3.702.446 6.638 3.382 7.084 7.084.006.053-.033.101-.087.107H11.5l-.123-.007c-.563-.06-1.002-.538-1.002-1.118V2.53c0-.054.043-.097.097-.097h.01z",
    transform: "translate(43 6)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C2154",
    strokeLinecap: "round",
    strokeWidth: 1.75,
    d: "M6.767 2.979C3.694 4.096 1.5 7.042 1.5 10.5c0 4.418 3.582 8 8 8 3.442 0 6.377-2.174 7.505-5.225",
    transform: "translate(43 6)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChart);
export default __webpack_public_path__ + "static/media/icon-chart.a78a043e.svg";
export { ForwardRef as ReactComponent };